var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BusinessMap"},[_c('GoogleMap',{attrs:{"id":"1","mapCenter":_vm.localizacion,"height":368,"heatmapData":_vm.heatmapData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }